import Tone from 'tone';
import {median} from 'utils/median.js';
//import {wasmWorker} from './tempo2.js';

let MIN_SIZE = 0.750;

export function getTempoAndOnsets(buffer, aubio, onsetThreshold) {
    //wasmWorker();
    let dateA = new Date().getTime();
    let orig = buffer.getChannelData(0);
    let origLength = orig.length;
    let duration = 1000*origLength/Tone.context.sampleRate;
    if (origLength/Tone.context.sampleRate < MIN_SIZE) {
        return {
            onsets: [],
            tempo: 0,
        };
    }
    
    let window_size = 1024;
    let hop_size = 256;
    let silence = -45;
    let session = aubio.asm._initTempo(
        window_size, hop_size, Tone.context.sampleRate, onsetThreshold, silence);
    let p = aubio._newBuffer(hop_size)
    let tempos = [];
    let onsets = new Set();
    let onsetToPitch = {};
    let numSlices = orig.length/hop_size- 1;
    let skipAfter = origLength/hop_size - 1;
    let pitches = [];
    for (let i=0; i < numSlices; i++) {
        let buffer = orig.subarray(i*hop_size, (i+1)*hop_size);
        aubio.HEAPF32.set(buffer, p >> 2);
        let hadOnset = aubio.asm._processTempo(session, p);
        let onset =  aubio.asm._getOnset(session);

        if (i === 0) {
            if (isValidVolume(buffer)) {
                hadOnset = 1;
            } else {
                hadOnset = 0;
            }
        }
        let tempo = aubio.asm._getTempo(session);
        tempos.push(tempo);
        if (hadOnset != 0 && i < skipAfter) {
            if (onset < duration * 0.8) {
                onsets.add(onset);
            }
        }
    }
    onsets = Array.from(onsets);
    aubio._destroyBuffer(p);
    aubio.asm._dispose(session);
    
    let tempo = median(tempos.filter(x => x != 0)) || 0;
    if (tempo > 180) {
        tempo = tempo / 2;
    } 
    let dateB = new Date().getTime();
    let time = dateB - dateA;
    return {
        tempo: tempo,
        onsets: onsets,
        onsetToPitch: onsetToPitch,
    };
}

function float32Concat(first, second) {
    var firstLength = first.length,
        result = new Float32Array(firstLength + second.length);
    
    result.set(first);
    result.set(second, firstLength);
        
    return result;
}

function isValidVolume(buffer) {
    let rms = Math.sqrt(buffer.reduce((a,b) => a + Math.pow(b, 2)) / buffer.length);
    let vol = rms > 0.1;
    return vol;
}


